const sanitizeBase = (value: string) => value.replace(/\/+$/, '');

const resolveDefaultBase = () => {
  if (typeof window === 'undefined') {
    return '/api';
  }
  return `${sanitizeBase(window.location.origin)}/api`;
};

const envApiUrl = (process.env.REACT_APP_API_URL || '').trim();
const isBrowser = typeof window !== 'undefined';
const isLocalHost =
  isBrowser &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

let baseUrl = envApiUrl;

if (!baseUrl) {
  baseUrl = resolveDefaultBase();
} else if (!isLocalHost && baseUrl.includes('localhost')) {
  // Prevent accidentally using a localhost API when deployed
  baseUrl = resolveDefaultBase();
} else {
  baseUrl = sanitizeBase(baseUrl);
}

export const API_BASE_URL = baseUrl;
